<template>
    <div>
        <div style="background: white" >
            <b-card no-body>
                <div class="card hovercard">
                    <div class="card-background">
                        <img class="card-bkimg" alt="" src="../../assets/img/brand/logo.png">
                        <!-- http://lorempixel.com/850/280/people/9/ -->
                    </div>
                    <div class="useravatar">
                        <img alt="" src="../../assets/img/avatars/avata1_user.png">
                    </div>
                    <div class="card-info">
                        <span v-for="(value, key) in customer">
                            <span class="card-title" v-if="key == 'Customer Name'" style="text-align: center">{{ value }}</span>
                        </span>
                    </div>
                </div>
                <b-tabs>
                    <b-tab title="Customer Info" active>
                        <!--<b-table striped hover :items="items" :fields="summary"></b-table>-->
                        <div class="row">
                            <div class="col-md-6">
                                <template v-for="(value, key) in customer">
                                    <template v-if="summary.includes(key)">
                                        <p>{{ key }}: {{ value }} </p>
                                    </template>

                                    <template v-if="bio.includes(key)">
                                        <template v-if="key == 'Address'">
                                            <small>
                                                <cite :title="value">
                                                    {{ value }} <i class="glyphicon glyphicon-map-marker"></i>
                                                </cite>
                                            </small>
                                        </template>
                                        <p>
                                            <template v-if="key == 'Email'">
                                                <i class="glyphicon glyphicon-envelope"></i>{{ value }}
                                            </template>
                                            <template v-if="key == 'Date of Birth'">
                                                <i class="glyphicon glyphicon-gift"></i>{{ value }}
                                            </template>
                                        </p>
                                    </template>
                                </template>
                            </div>
                            <div class="col-md-6">
                                <div class="panel panel-primary panel-pricing">
                                    <div class="panel-heading">
                                        <h5>Products</h5>
                                    </div>
                                    <ul class="list-group text-center">
                                        <template v-for="(value, key) in customer">
                                            <template v-if="products.includes(key)">
                                                <template class="tags" v-if="value == 1">
                                                    <li class="list-group-item" >
                                                        <i class="fa fa-check"></i>
                                                        {{ key }}
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Account Summary">
                        <div v-for="(value, key) in customer">
                            <div v-if="transactions.includes(key)">
                                <p>{{ key }}: {{ value }} </p>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Upsell/Cross-sell">
                        <ul class="list-group text-center">
                                        <template v-for="(value, key) in customer">
                                            <template v-if="products.includes(key)">
                                                <template class="tags" v-if="value == 0">
                                                    <li class="list-group-item" >
                                                        <i class="fa fa-check"></i>
                                                        {{ key }}
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                            </ul>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
  // import json from './json/customer_360.json';
  export default{
      name: 'View360',
      mounted: function () {
          console.log('mounted');
          const customerid = parseInt(this.$route.params.id, 10);
          console.log(customerid);
          this.customer = this.$store.getters.getCustomerProfileById(customerid);
          // console.log(this.customer);
      },
      data() {
          return {
              summary: ['Customer ID', 'Customer Name', 'Gender', 'Age', 'Account Age (Years)', 'CreditScore (%)', 'Location'],
              bio: ['Date of Birth', 'Address', 'Email', 'Postal Address', 'Location'],
              transactions: ['Customer ID', 'Current Account', 'Savings Account', 'Investments', 'Over-Draft', 'Mortgage'],
              products: ['Current Account', 'Savings Account', 'Investments', 'Over-Draft', 'Mortgage',
                  'Lifestyle Plus Loan', 'Elite Kids Savings', 'Funky and Fresh'],
              customer: {}
          };
      }
  };
</script>

<style scoped>
    /* USER PROFILE PAGE */
    .card {
        margin-top: 20px;
        padding: 30px;
        background-color: rgba(214, 224, 226, 0.2);
        -webkit-border-top-left-radius:5px;
        -moz-border-top-left-radius:5px;
        border-top-left-radius:5px;
        -webkit-border-top-right-radius:5px;
        -moz-border-top-right-radius:5px;
        border-top-right-radius:5px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    .card.hovercard {
        position: relative;
        padding-top: 0;
        overflow: hidden;
        text-align: center;
        background-color: #fff;
        background-color: rgba(255, 255, 255, 1);
    }
    .card.hovercard .card-background {
        height: 130px;
    }
    .card-background img {
        -webkit-filter: blur(25px);
        -moz-filter: blur(25px);
        -o-filter: blur(25px);
        -ms-filter: blur(25px);
        filter: blur(25px);
        margin-left: -100px;
        margin-top: -200px;
        min-width: 130%;
    }
    .card.hovercard .useravatar {
        position: absolute;
        top: 15px;
        left: 0;
        right: 0;
    }
    .card.hovercard .useravatar img {
        width: 100px;
        height: 100px;
        max-width: 100px;
        max-height: 100px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        border: 5px solid rgba(255, 255, 255, 0.5);
    }
    .card.hovercard .card-info {
        position: absolute;
        bottom: 14px;
        left: 0;
        right: 0;
    }
    .card.hovercard .card-info .card-title {
        padding:0 5px;
        font-size: 20px;
        line-height: 1;
        color: #262626;
        background-color: rgba(255, 255, 255, 0.1);
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .card.hovercard .card-info {
        overflow: hidden;
        font-size: 12px;
        line-height: 20px;
        color: #737373;
        text-overflow: ellipsis;
    }
    .card.hovercard .bottom {
        padding: 0 20px;
        margin-bottom: 17px;
    }
    .panel-pricing {
        -moz-transition: all .3s ease;
        -o-transition: all .3s ease;
        -webkit-transition: all .3s ease;
    }
    .panel-pricing:hover {
        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
    }
    .panel-pricing .panel-heading {
        padding: 20px 10px;
    }
    .panel-pricing .panel-heading .fa {
        margin-top: 10px;
        font-size: 58px;
    }
    .panel-pricing .list-group-item {
        color: #777777;
        border-bottom: 1px solid rgba(250, 250, 250, 0.5);
    }
    .panel-pricing .list-group-item:last-child {
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
    }
    .panel-pricing .list-group-item:first-child {
        border-top-right-radius: 0px;
        border-top-left-radius: 0px;
    }
    .panel-pricing .panel-body {
        background-color: #f0f0f0;
        font-size: 40px;
        color: #777777;
        padding: 20px;
        margin: 0px;
    }
</style>
